/* =====================================================================
   GARDEN EQUIPMENT — Moteur d'animations (reproduction React)
   - Reveal : fade+slide au scroll (équiv. composant Reveal.tsx)
   - Count-up : chiffres animés au scroll (KeyFigures / stats)
   - Dark mode : toggle persisté (équiv. useTheme)
   Vanilla JS, aucune dépendance. Respecte prefers-reduced-motion.
   ===================================================================== */
(function () {
  "use strict";

  var reduce =
    window.matchMedia &&
    window.matchMedia("(prefers-reduced-motion: reduce)").matches;

  /* ---------- 1. REVEAL au scroll ---------- */
  function initReveal() {
    var els = document.querySelectorAll(".ge-reveal:not(.is-visible)");
    if (!els.length) return;

    if (reduce || !("IntersectionObserver" in window)) {
      els.forEach(function (el) {
        el.classList.add("is-visible");
      });
      return;
    }

    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          var el = entry.target;
          // Un bloc plus haut que l'écran (CGV, mentions légales...) ne peut jamais être
          // visible à 15 % : sans ce garde-fou il restait invisible (opacité 0) pour toujours.
          var tall = entry.boundingClientRect.height > window.innerHeight * 0.6;
          if (entry.intersectionRatio < 0.15 && !tall) return;
          var delay = parseInt(el.getAttribute("data-ge-delay") || "0", 10);
          if (delay) el.style.transitionDelay = delay + "ms";
          el.classList.add("is-visible");
          io.unobserve(el);
        });
      },
      { threshold: [0, 0.15], rootMargin: "0px 0px -8% 0px" }
    );

    els.forEach(function (el) {
      io.observe(el);
    });
  }

  /* ---------- 2. COUNT-UP (chiffres animés) ----------
     Usage : <span class="ge-countup" data-ge-target="15" data-ge-duration="1600"
                    data-ge-decimals="0">0</span>
     Le préfixe/suffixe (+, %, kg…) reste en dehors du span. */
  function easeOutCubic(t) {
    return 1 - Math.pow(1 - t, 3);
  }

  function runCountUp(el) {
    var target = parseFloat(el.getAttribute("data-ge-target") || "0");
    var duration = parseInt(el.getAttribute("data-ge-duration") || "1600", 10);
    var decimals = parseInt(el.getAttribute("data-ge-decimals") || "0", 10);

    if (reduce) {
      el.textContent = target.toFixed(decimals);
      return;
    }

    var start = null;
    function frame(ts) {
      if (start === null) start = ts;
      var p = Math.min((ts - start) / duration, 1);
      var value = target * easeOutCubic(p);
      el.textContent = value.toFixed(decimals);
      if (p < 1) requestAnimationFrame(frame);
      else el.textContent = target.toFixed(decimals);
    }
    requestAnimationFrame(frame);
  }

  function initCountUp() {
    var els = document.querySelectorAll(".ge-countup:not([data-ge-done])");
    if (!els.length) return;

    if (reduce || !("IntersectionObserver" in window)) {
      els.forEach(function (el) {
        el.setAttribute("data-ge-done", "1");
        runCountUp(el);
      });
      return;
    }

    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          var el = entry.target;
          el.setAttribute("data-ge-done", "1");
          runCountUp(el);
          io.unobserve(el);
        });
      },
      { threshold: 0.35 }
    );

    els.forEach(function (el) {
      io.observe(el);
    });
  }

  /* ---------- 3. DARK MODE (toggle persisté) ---------- */
  var STORE_KEY = "ge-theme";

  function applyTheme(theme) {
    var root = document.documentElement;
    if (theme === "dark") root.classList.add("ge-dark");
    else root.classList.remove("ge-dark");
    document.querySelectorAll("[data-ge-theme-toggle]").forEach(function (btn) {
      btn.setAttribute("aria-pressed", theme === "dark" ? "true" : "false");
    });
  }

  function currentTheme() {
    try {
      return localStorage.getItem(STORE_KEY) === "dark" ? "dark" : "light";
    } catch (e) {
      return "light";
    }
  }

  function initTheme() {
    applyTheme(currentTheme());
    document.addEventListener("click", function (e) {
      var btn = e.target.closest && e.target.closest("[data-ge-theme-toggle]");
      if (!btn) return;
      e.preventDefault();
      var next = currentTheme() === "dark" ? "light" : "dark";
      try {
        localStorage.setItem(STORE_KEY, next);
      } catch (err) {}
      applyTheme(next);
    });
  }

  /* ---------- Boot ---------- */
  function boot() {
    initTheme();
    initReveal();
    initCountUp();
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", boot);
  } else {
    boot();
  }

  // Réinitialise dans l'éditeur de thème Shopify (sections rechargées)
  document.addEventListener("shopify:section:load", function () {
    initReveal();
    initCountUp();
    applyTheme(currentTheme());
  });
})();
